import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPencil = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 19,
	fill: "none",
	viewBox: "0 0 16 19",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "m9 .6-9 9V15h5.4l9-9L9 .6zM2 13v-2.6l7-7L11.6 6l-7 7H2z",
		clipRule: "evenodd"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M0 19h16v-2H0v2z"
	})]
});
export default SvgPencil;
